/* A Releasit acha o cliente pelo celular e tenta trocar o e-mail dele pelo digitado.
   Se esse e-mail pertence a outro cliente, a Shopify recusa e o pedido nao e criado.
   Nesse caso o pedido e reenviado uma vez sem o e-mail, e fica no cliente do celular. */
(function () {
  if (window.__SV_EMAIL_TAKEN_RETRY) return;
  window.__SV_EMAIL_TAKEN_RETRY = true;

  var lastCreateUrl = '';
  var retried = false;
  var tries = 0;

  function isPlainCreate() {
    try {
      return !!lastCreateUrl && lastCreateUrl === String(window._rsi.s.form.postUrl);
    } catch (e) {
      return false;
    }
  }

  var timer = setInterval(function () {
    tries++;
    var rsi = window._rsi;
    try {
      if (rsi && rsi.u && typeof rsi.u.ajax === 'function' && !rsi.u.ajax.__svEmailRetryAjax) {
        var origAjax = rsi.u.ajax;
        var wrappedAjax = function (method, url) {
          try {
            if (String(url || '').indexOf('create-order') !== -1) lastCreateUrl = String(url);
          } catch (e) {}
          return origAjax.apply(this, arguments);
        };
        wrappedAjax.__svEmailRetryAjax = true;
        rsi.u.ajax = wrappedAjax;
      }

      if (rsi && rsi.form && typeof rsi.form.handleOrderErrors === 'function' && !rsi.form.handleOrderErrors.__svEmailRetry) {
        var origErrors = rsi.form.handleOrderErrors;
        var wrappedErrors = function (message, payload) {
          var taken = typeof message === 'string' && /email address has already been taken/i.test(message);
          var canResend = taken && !retried && isPlainCreate()
            && payload && Array.isArray(payload.formData)
            && rsi.upsells && rsi.upsells.isPostPurchase;
          if (canResend) {
            retried = true;
            try {
              var copy = JSON.parse(JSON.stringify(payload));
              copy.formData = copy.formData.map(function (field) {
                return field && field.name === 'email' ? { name: 'email', value: '' } : field;
              });
              rsi.s.form.currentPage = 'init';
              rsi.form.onSubmit(false, true, copy, true);
              return;
            } catch (e) {}
          }
          return origErrors.apply(this, arguments);
        };
        wrappedErrors.__svEmailRetry = true;
        rsi.form.handleOrderErrors = wrappedErrors;
      }
    } catch (e) {}
    if (tries > 600) clearInterval(timer);
  }, 100);
})();
